import Model from "../Model";

class AddRelation extends Model{

    buildUrl ({ param }) {
        return ['userrelation/insert', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }

    create(form) {
        return this.request({
            action: 'store',
            method: 'POST',
            data: form
        });
    }
}


export default new AddRelation;